import { FormattedMessage } from 'react-intl'
import Flex from 'styled-flex-component'

import HeadTag from '@components/UI/HeadTag'
import MainLayout from '@components/UI/MainLayout'
import image404 from '@images/404-page.png'
import Theme from '@theme'
import { Container, Text } from '@tribegroup'
import { Image, JumboHeader, MainContainer, TextWrapper } from './404.styled'

export const CampaignCreators404 = () => (
  <MainLayout backgroundColor={Theme.whiteColor} data-testid="campaign-creators-404-error-page">
    <HeadTag id="campaignCreators.header.title" />
    <MainContainer>
      <Flex center>
        <Image src={image404} alt="page 404" />
      </Flex>
      <TextWrapper>
        <div>
          <JumboHeader color={Theme.primaryColor}>
            <FormattedMessage id="campaignCreators.404.title1" />
          </JumboHeader>
          <JumboHeader color={Theme.defaultColor}>
            <FormattedMessage id="campaignCreators.404.title2" />
          </JumboHeader>
          <Container topOuterSpacing={0.3125}>
            <Text color={Theme.defaultColor} small>
              <FormattedMessage id="campaignCreators.404.subtitle" />
            </Text>
          </Container>
        </div>
      </TextWrapper>
    </MainContainer>
  </MainLayout>
)

export default CampaignCreators404
